import { render, staticRenderFns } from "./PerformanceReportEmbedded.vue?vue&type=template&id=6e6d116e"
import script from "./PerformanceReportEmbedded.vue?vue&type=script&lang=js"
export * from "./PerformanceReportEmbedded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QPage from 'quasar/src/components/page/QPage.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QPage});
